
<div class="container marginMobile">
        <div class="row border rounded p-3 mb-5">
          <div class="col-sm-12 titreRubrique text-center my-3">
                  Les marques
                  <div class="separTitres"></div>
        </div>
      <div *ngFor="let fornisseur of fornisseurs | keyvalue" class="col-12 col-md-4 col-xl-3">
        <a [routerLink]="['/marque/',fornisseur.key]" class="marqueItem">{{fornisseur.value}}</a>
      </div>
    </div>
  </div>
